/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['require', '../appContext', 'knockout'],
function (require, app, ko) {
    "use strict";

    function FontStyle() {
        var self = {};

        self.family = ko.observable("Arial, Verdana, sans-serif");
        self.weight = ko.observable("Normal");
        self.size = ko.observable("12");
        self.cssString = ko.computed(function () {
            return self.size() + "px " + self.family() + " " + self.weight();
        });

        self.clone = function () {
            var n = new FontStyle();

            n.family(self.family());
            n.weight(self.weight());
            n.size(self.size());

            return n;
        }

        self.dispose = function () {
            self.family = null;
            self.weight = null;
            self.size = null;
            self = null;
        }

        return self;
    }

    return FontStyle;
});
